import React from "react";
import styleClasses from "../../Header/Header.module.scss";
import rewardIcon from '../../../images/Reward.svg';
import useCheckMobileScreen from "../../../hooks/useCheckMobileScreen";
import { useLocation } from "react-router-dom";
import { useIsDesignV2 } from "../../../hooks/useIsDesignV2";

interface IAutoRedeemToggle {
    handleAutoUseReward?: () => void;
    autoRedeem: boolean;
    isLoading: boolean;
}

const AutoRedeemToggle: React.FC<IAutoRedeemToggle> = (props) => {
    const {
        handleAutoUseReward,
        autoRedeem,
        isLoading
    } = props;
    const isItMobile = useCheckMobileScreen();
    const location = useLocation();
    const isDesignV2 = useIsDesignV2();
    return (
         <>
            <div className={`${styleClasses.use_reward} ${isDesignV2 ? `theme-check-box-mobile-designv2 ${styleClasses.use_reward_mobile_designv2}` : ''}`}>
          <div className={`form-group theme_check_boxes Switch_btn rounded mb-0`}>
                  <input
                    disabled={isLoading}
                    type="checkbox"
                    id={`radiobox_cart`}
                    name="address_group"
                    checked={autoRedeem}
                    onChange={handleAutoUseReward}
                  />
                  <label
                    htmlFor={`radiobox_cart`}
                    className= {`d-flex align-items-center f-s18 f-sm-s16 ${isDesignV2 ? 'justify-content-start ms-2' : 'justify-content-center'}`}
                    data-testid="auto-redeem-label-on-cart"
                  >
                <span className={`box_wrap mt-1 ${isLoading ? 'is_toggle_disabled' : ''}`}></span>
                    <span
                className={`${styleClasses.info_label} d-flex justify-content-between
                font-Visby-cf f-s14 clr-dark-blue ${isDesignV2 ? 'align-items-end f-s15 f-w6' : 'f-w9 align-items-center'} ${isLoading ? 'is_toggle_disabled' : ''}`}
                    >
                      <img
                        src={rewardIcon}
                        className={`img-fluid me-2 ${isDesignV2 ? 'redeem-image-mobile-designv2 mt-2' : ''}`}
                        alt="reward"
                      />{" "}
                      Automatically Use My Rewards
                    </span>
                  </label>
                </div>
            </div>
           {!isDesignV2 && <hr className="shadow-divider mb-4 border-0" />}
        </>
  );
};

export default AutoRedeemToggle;
